'use client'

interface LoadingProps {
  size?: 'sm' | 'md' | 'lg'
  color?: string
  className?: string
  center?: boolean // If to center the spinner (default: true).
}

export default function Loading({
  size = 'md',
  color,
  className = '',
  center = true
}: LoadingProps) {
  const sizeStyles = {
    sm: { width: '1rem', height: '1rem', borderWidth: '0.1em' }, // Thin spinner
    md: {},
    lg: {}
  }[size]

  const spinnerClass = color ? '' : 'text-primary'

  const spinner = (
    <div
      className={`spinner-border ${spinnerClass} ${className}`}
      style={{
        ...sizeStyles,
        ...(color ? { color, borderRightColor: 'transparent' } : {})
      }}
      role="status"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  )

  return center ? (
    <div className="d-flex justify-content-center align-items-center">
      {spinner}
    </div>
  ) : (
    spinner
  )
}
